<template>
  <v-row dense>
    <v-col>
      <navigation-drawer
        color="white"
        :depth="1"
        permanent
        clipped
        fixed
        class="pt-8"
        :width="250"
      >
        <v-list dense class="mb-10">
          <v-list-item dense v-for="(surgeryGroup, key) in surgeryGroups" :key="key">
            <v-list-item-content>
              <v-list-item-title>
                <v-row dense>
                  <v-col class="text-body-1 gray--text text--lighten-1 font-weight-bold">
                    <v-tooltip top max-width="450">
                      <template v-slot:activator="{ on, attrs }">
                        <span :attrs="attrs" v-on="on">
                          {{ key | truncate(24) }}
                        </span>
                      </template>

                      <span>
                        {{ key }}
                      </span>
                    </v-tooltip>
                  </v-col>

                  <v-col cols="auto">
                    <v-btn icon small @click="toggleShowSurgeryGroupKey(key, surgeryGroup)">
                      <v-icon v-if="showSurgeryGroupKey === key">eva-chevron-up-outline</v-icon>
                      <v-icon v-else>eva-chevron-down-outline</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-list-item-title>

              <v-timeline dense v-show="showSurgeryGroupKey === key">
                <v-timeline-item
                  v-for="item in surgeryGroup"
                  :key="item.id"
                  :color="item.id === surgeryId ? 'primary' : 'gray lighten-1'"
                  small
                >
                  <v-row dense>
                    <v-col>
                      <v-btn text block small @click="surgeryId = item.id">
                        {{
                          $moment(item.createdAt, "YYYY-MM-DD HH:mm:ss ZZ")
                            | moment("DD MMMM Y")
                        }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-timeline-item>
              </v-timeline>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </navigation-drawer>

      <v-row style="padding-left: 250px">
        <v-col>
          <v-row>
            <v-col class="text-h3 gray--text text--lighten-1">Cirurgias</v-col>
          </v-row>

          <v-row v-if="surgery">
            <v-col>
              <v-tabs background-color="transparent" color="secondary">
                <v-tab @click="surgeryMoment = 'details'">Detalhes</v-tab>
                <v-tab @click="surgeryMoment = 'preoperative'">Pré-operatório</v-tab>
                <v-tab @click="surgeryMoment = 'intraoperative'">Intra-operatório</v-tab>
                <v-tab @click="surgeryMoment = 'postoperative'">Pós-operatório</v-tab>
              </v-tabs>

              <v-tabs-items v-model="surgeryMoment" style="background-color: transparent">
                <v-tab-item value="details">
                  <Details
                    :surgery="surgery"
                    :refreshSurgery="refreshSurgery"
                    :surgeryMoment="surgeryMoment"
                    :setSurgeryMoment="() => {}"
                    :disabled="true"
                  />
                </v-tab-item>

                <v-tab-item value="preoperative">
                  <Preoperative
                    :surgery="surgery"
                    :refreshSurgery="refreshSurgery"
                    :surgeryMoment="surgeryMoment"
                    :setSurgeryMoment="() => {}"
                    :disabled="true"
                  />
                </v-tab-item>

                <v-tab-item value="intraoperative">
                  <Intraoperative
                    :surgery="surgery"
                    :refreshSurgery="refreshSurgery"
                    :surgeryMoment="surgeryMoment"
                    :setSurgeryMoment="() => {}"
                    :disabled="true"
                  />
                </v-tab-item>

                <v-tab-item value="postoperative">
                  <Postoperative
                    :surgery="surgery"
                    :refreshSurgery="refreshSurgery"
                    :surgeryMoment="surgeryMoment"
                    :setSurgeryMoment="() => {}"
                    :disabled="true"
                  />
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  import Details from "@/views/surgeries/surgery/details.vue";
  import Preoperative from "@/views/surgeries/surgery/preoperative.vue";
  import Intraoperative from "@/views/surgeries/surgery/intraoperative.vue";
  import Postoperative from "@/views/surgeries/surgery/postoperative.vue";

  export default {
    props: {
      patient: Object,
    },
    components: {
      Details,
      Preoperative,
      Intraoperative,
      Postoperative,
    },
    data() {
      return {
        surgeryId: null,
        showSurgeryGroupKey: false,
        surgeryMoment: "details",
      };
    },
    mounted() {
      let surgery = this.lodash.first(this.surgeries);

      if (surgery) {
        this.surgeryId = surgery.id;
        this.showSurgeryGroupKey = surgery.surgeryIndication.surgeryType.name;
      }
    },
    apollo: {
      surgery: {
        query: require("@/graphql/surgery/surgery.gql"),
        variables() {
          return {
            surgeryId: this.surgeryId,
          };
        },
        pollInterval: 1000,
        skip() {
          return this.lodash.isEmpty(this.surgeryId);
        },
      },
    },
    computed: {
      surgeries() {
        return this.lodash.orderBy(
          this.patient.surgeries,
          [
            function(o) {
              return this.$moment(o.createdAt, "YYYY-MM-DD HH:mm:ss ZZ");
            }.bind(this),
          ],
          ["desc"]
        );
      },
      surgeryGroups() {
        const unordered = this.lodash.groupBy(
          this.surgeries,
          "surgeryIndication.surgeryType.name"
        );
        const ordered = {};
        Object.keys(unordered)
          .sort()
          .forEach(function(key) {
            ordered[key] = unordered[key];
          });
        return ordered;
      },
    },
    methods: {
      toggleShowSurgeryGroupKey(key, surgeryGroup) {
        if (this.showSurgeryGroupKey === key) {
          this.showSurgeryGroupKey = "";
        } else {
          this.showSurgeryGroupKey = key;
          this.surgeryId = this.lodash.first(surgeryGroup).id;
        }
      },
      refreshSurgery() {
        return this.$apollo.queries.surgery.refetch();
      },
      setSurgeryMoment(moment) {
        this.surgeryMoment = moment;
      },
    },
  };
</script>

<style lang="scss" scoped></style>
